define([
    "csi/config",
	"dojo/_base/declare",
	"SiteAdmin/AttributeMap/AttributeMapTable",
	"./PartMaterialAttributeMapTable"
], function(config,declare,AttributeMapTable,PartMaterialAttributeMapTable) {

	var SETTINGS_URL = "centric://REFLECTION/INSTANCE/CostMaterialConfig/Settings";
	var SETUP_SETTINGS_URL = "centric://REFLECTION/INSTANCE/CostMaterialConfig/SetupSettings";
	var MAP_SETTING_ID = "PartMaterialKeysMap";
	var MAP_ENTRY_NODE_TYPE = "_PartMaterialKeysMapEntry_";
	var DEST_ATTR_ID_ATTR = "PartMaterialKeysId";

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	return declare(PartMaterialAttributeMapTable, {
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR
	});
});